import { ViewController, ClockView, ClockViewDelegate, CallToActionView, MatchdayAreaModel, Gradient,
         ModelUpdateEvent, TimeUpdateEvent } from "@gaming/srvg-classes-core";

// Uses srvg.server

/*
* Most of the action regarding the countdown views should happen here:
*  color, text, animation, and state of the clock
*  state of the lock
*  progress and state of the progressview
*  color, text, animation, and state of the text area
*  color, text, animation, and state of the Product logo
*
*/

export class CallToActionViewController extends ViewController implements ClockViewDelegate {
    public name: string;
    callToActionView: CallToActionView;
    matchdayAreaModel: MatchdayAreaModel;

    max: number;
    current: number;

    // animation settings
    start_animation: number; // countdown at which to start blinking
    blinkFadeTime: number;
    blinkInterval: any;

    placeYourBetsText: string;
    betStopText: string;

    gradient: Gradient;

    hasToColorizeBackground: boolean;

    private timeOfTimeout: number;

    constructor( options ) {
        options = options || { };
        options.view = options.callToActionView || null;
        super( options );
        this.name = 'calltoactionController';

        this.callToActionView = options.callToActionView || null;

        this.matchdayAreaModel = options.matchdayAreaModel || null;

        this.max = 0;
        this.current = 0;

        this.start_animation = options.start_animation || 10;
        this.blinkInterval = null;
        this.blinkFadeTime = 300;

        this.placeYourBetsText = options.placeYourBetsText || __('Place your bets');
        this.betStopText = options.betStopText || __('Betstop');

        // color gradient for text color
        this.gradient = options.gradient || new Gradient( [
            jQuery.Color('#ff0000'), // red
            jQuery.Color('#ff7f00'), // orange
            jQuery.Color('#ffff00'), // yellow
            jQuery.Color('#00ff00')  // green
        ] );

        // Hack: use invisibility of progress view as indicator that the background color has to
        // be affected by the gradient.
        this.hasToColorizeBackground = this.callToActionView.progressView.$domNode.is(':hidden');

        this.callToActionView.clockView.setDelegate( this );

        this.timeOfTimeout = 0;
    }

    private refreshForBetstop() {
        this.callToActionView.textView.setText( this.betStopText );
        this.resetColor();
        this.stopBlinking();
        this.callToActionView.clearCountdown();
    }

    private refreshForBetting() {
        this.callToActionView.textView.setText( this.placeYourBetsText );
    }

    private updateMax( now, timeOfNextBetstop ) {
        var timeOfLastBetstop = 0;
        if( this.matchdayAreaModel.currentMatchday.betstop() >= now ) {
            // current or future betstop
            if( this.matchdayAreaModel.currentMatchday.prev ) {
                // calculate with betstop of last matchday
                timeOfLastBetstop = this.matchdayAreaModel.currentMatchday.prev.betstop()/* + srvg.timelinePhases.betstop.length*/;
            }
            else {
                // calculate using phase lengths (should happen only on first day of the season)
                var phaseLengths = srvg.timelinePhases;
                timeOfLastBetstop = this.matchdayAreaModel.currentMatchday.start
                    - parseInt(phaseLengths.post_competition.length)
                    - parseInt(phaseLengths.sportevent.length)
                    - parseInt(phaseLengths.post_sportevent.length)
                    - parseInt(phaseLengths.betstop.length);
            }
        }
        else {
            // betstop in the past
            timeOfLastBetstop = this.matchdayAreaModel.currentMatchday.betstop()/* + srvg.timelinePhases.betstop.length*/;
        }

        this.max = timeOfNextBetstop-timeOfLastBetstop;
        this.current = now-timeOfLastBetstop;
    }

    // ************************** Event handlers **************************

    handleModelUpdateEvent( event:ModelUpdateEvent, provider ) {
        // console.log( 'handleModelUpdateEvent' );
        if( event.propertyName == 'selectedMatchday' ) {
            if( this.timeOfTimeout ) {
                //console.log( app.server.getTime() - this.timeOfTimeout, ' seconds since countdown stopped' );
            }
            if( !this.matchdayAreaModel.currentMatchday ) {
                return;
            }

            if( this.callToActionView.seasonNrView ) {
                this.callToActionView.seasonNrView.setText( this.matchdayAreaModel.selectedMatchday.getSeason().nr.toString() );
            }
            if( this.callToActionView.matchdayNrView ) {
                this.callToActionView.matchdayNrView.setText( this.matchdayAreaModel.selectedMatchday.nr.toString() );
            }

            var now = app.server.getTime();
            if( this.matchdayAreaModel.selectedMatchday.betstop() > now ) {
                //console.log( '...betstop of matchday', this.matchdayAreaModel.selectedMatchday.nr, ' is in the future' );
                this.refreshForBetting();
                this.updateMax( now, this.matchdayAreaModel.selectedMatchday.betstop() );
                this.callToActionView.setPosition( this.max - this.current );
            }
            else {
                //console.log( '...betstop of matchday', this.matchdayAreaModel.selectedMatchday.nr, ' is now or in the past' );
                this.refreshForBetstop();
            }
        }
    }

    handleTimeoutEvent( event, provider ) {
        //console.log( 'handleTimeoutEvent' );
        if( provider == app.inactivityController ) {
            // idle timeout
            this.stopBlinking();
            this.callToActionView.deactivate();
            this.callToActionView.progressView.clear();
        }
        else {
            // counter is finished
            this.timeOfTimeout = app.server.getTime();
            this.callToActionView.clockView.stop();
        }
    }

    handleTimeUpdateEvent( event: TimeUpdateEvent, provider: ClockView ) {
        //console.log( 'handleTimeUpdateEvent', event.time );
        var secondsLeft = event.time;
        if ( secondsLeft <= this.start_animation && ! this.isBlinking() ) {
            this.startBlinking();
        }
        if ( secondsLeft<=0 || secondsLeft > this.start_animation && this.isBlinking() ) {
            this.stopBlinking();
        }

        // FIXME (maybe) time on 1st matchday: progressOff during pre_season phase?

        var progressOff = false;

        var now = app.server.getTime();

        if( this.matchdayAreaModel.selectedMatchday && this.matchdayAreaModel.currentMatchday && this.matchdayAreaModel.selectedMatchday.isGreaterThan( this.matchdayAreaModel.currentMatchday ) ) {
            if( this.matchdayAreaModel.currentMatchday.betstop()/*+srvg.timelinePhases.betstop.length*/ >= now ) {
                progressOff = true;
            }
            if( this.matchdayAreaModel.currentMatchday.next && ! this.matchdayAreaModel.currentMatchday.next.isEqualTo( this.matchdayAreaModel.selectedMatchday ) ) {
                if( this.matchdayAreaModel.currentMatchday.betstop()/*+srvg.timelinePhases.betstop.length*/ < now ) {
                    progressOff = true;
                }
            }
        }

        if( progressOff ) {
            this.max=secondsLeft;
            this.current=secondsLeft;
        }
        this.callToActionView.progressView.setPosition( 1-(secondsLeft/this.max) );

        this.colorize( secondsLeft/this.max );
    }

    // ************************** Colorization functions **************************

    /**
     * Colorize all subviews using the given fraction of the gradient
     */
    private colorize( fraction:number ) {
        //console.log( 'colorize()', fraction );

        var color = this.gradient.getInterpolatedColor( fraction );

        var that = this;

        this.view.subViews.forEach( function( view )  {
            // for collapsed mode it is needed to recognize which mode is set.
            // if the progressbar is not visible the background color is colorized too.
            if (that.hasToColorizeBackground){
                view.$domNode.find('.clock-min, .clock-hrs, .clock-sec').css('backgroundColor', color);
            }

            view.$domNode.css('color', color);

            var shadow = view.$domNode.css( 'text-shadow' );
            if( shadow && shadow != 'none' ) {
                // colorize glow
                view.$domNode.css( 'text-shadow', shadow.replace( /rgb\([^\)]+\)/g, color ) );
            }
        } );
    }

    // start blinking at the end of the countdown
    startBlinking() {
        var that = this;
        var anim = function () {
            that.callToActionView.subViews.forEach( function( view )  {
                if( view.objectId != that.callToActionView.lockView.objectId ) {
                    view.$domNode.fadeOut(that.blinkFadeTime).fadeIn(that.blinkFadeTime);
                }
            } );
        };
        this.blinkInterval = setInterval(anim, 1000);
    }

    // animation stop
    stopBlinking() {
        if( this.blinkInterval ) {
            clearInterval(this.blinkInterval);
            var that = this;
            this.blinkInterval = null;
            this.callToActionView.subViews.forEach( function( view )  {
                if( view.objectId != that.callToActionView.lockView.objectId ) {
                    view.$domNode.stop(true, true).css('display', ''); // don't use show() because that sets display:block;
                }
            } );
            this.resetColor();
        }
    }

    // is the animation running?
    isBlinking() {
        return this.blinkInterval;
    }

    resetColor() {
        var shadow;
        var color = this.gradient.getInterpolatedColor(0);
        shadow = this.callToActionView.logoView.$domNode.css( 'text-shadow' );
        if( shadow && shadow != 'none' ) {
            this.callToActionView.logoView.$domNode.css( 'text-shadow', shadow.replace( /rgb\([^\)]+\)/g, color ) );
        }
        shadow = this.callToActionView.textView.$domNode.css( 'text-shadow' );
        if( shadow && shadow != 'none' ) {
            this.callToActionView.textView.$domNode.css( 'text-shadow', shadow.replace( /rgb\([^\)]+\)/g, color ) );
        }
    }
}